import $http from '$http'
import {
    util
} from 'utils';
import {
    lg
} from 'utils';

export default {
    methods: {
        //POST /api/NewAgent/NewCompanyAdd
        NewCompanyAdd(data) {
            this.loading = true;
            $http.post('api/NewAgent/NewCompanyAdd', data).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '新增成功',
                        type: 'success'
                    });

                    this.$emit('reload-list');
                    this.close();
                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/addCompany/services.js